/**
 * Loader component using react-spinners and framer-motion
 * @returns <Loader />
 */

import { motion } from "framer-motion";
import { BarLoader } from "react-spinners";

const LoaderMini = () => {
    return (
        <motion.div style={{ height: "200px", weight: "100vw", display: "flex", justifyContent: "center", alignItems: "center" }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
        >
            <BarLoader />
        </motion.div>
    )
}

export default LoaderMini